/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { AdminActivatependinguserBody } from '../models';
import { AdminActivateusermanuallyBody } from '../models';
import { CreateOrganization } from '../models';
import { CreateUser } from '../models';
import { OrgTreeDto } from '../models';
import { Organization } from '../models';
import { OrganizationIdCreatorBody } from '../models';
import { RefreshTokenDto } from '../models';
import { UpdateFirebaseTokenDto } from '../models';
import { UpdateOrganizationDto } from '../models';
import { UpdateUser } from '../models';
import { UserTable } from '../models';
/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Activa un usuario pendiente por email
     * @param {AdminActivatependinguserBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerActivatePendingUser: async (
      body: AdminActivatependinguserBody,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerActivatePendingUser.'
        );
      }
      const localVarPath = `/admin/activate-pending-user`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Activa un usuario pendiente manualmente (solo marsi)
     * @param {AdminActivateusermanuallyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerActivateUserManually: async (
      body: AdminActivateusermanuallyBody,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerActivateUserManually.'
        );
      }
      const localVarPath = `/admin/activate-user-manually`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Clears all cached data from memory. Use with caution!
     * @summary Clear all cache keys from memory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerClearCache: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/cache/clear`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a new organization
     * @param {CreateOrganization} body Organization data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerCreateOrganization: async (
      body: CreateOrganization,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerCreateOrganization.'
        );
      }
      const localVarPath = `/admin/organizations/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a new user
     * @param {CreateUser} body User data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerCreateUser: async (
      body: CreateUser,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerCreateUser.'
        );
      }
      const localVarPath = `/admin/users/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes an organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteOrganization: async (
      organization_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'organization_id' is not null or undefined
      if (organization_id === null || organization_id === undefined) {
        throw new RequiredError(
          'organization_id',
          'Required parameter organization_id was null or undefined when calling adminControllerDeleteOrganization.'
        );
      }
      const localVarPath = `/admin/organization/{organization_id}`.replace(
        `{${'organization_id'}}`,
        encodeURIComponent(String(organization_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Elimina un usuario pendiente (solo marsi)
     * @param {string} pending_user_id Pending user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeletePendingUser: async (
      pending_user_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pending_user_id' is not null or undefined
      if (pending_user_id === null || pending_user_id === undefined) {
        throw new RequiredError(
          'pending_user_id',
          'Required parameter pending_user_id was null or undefined when calling adminControllerDeletePendingUser.'
        );
      }
      const localVarPath = `/admin/pending-users/{pendingUserId}`.replace(
        `{${'pendingUserId'}}`,
        encodeURIComponent(String(pending_user_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes a user
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteUser: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling adminControllerDeleteUser.'
        );
      }
      const localVarPath = `/admin/users/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves a single organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerFindOneOrganization: async (
      organization_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'organization_id' is not null or undefined
      if (organization_id === null || organization_id === undefined) {
        throw new RequiredError(
          'organization_id',
          'Required parameter organization_id was null or undefined when calling adminControllerFindOneOrganization.'
        );
      }
      const localVarPath = `/admin/organization/{organization_id}`.replace(
        `{${'organization_id'}}`,
        encodeURIComponent(String(organization_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves a single user
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerFindOneUser: async (
      user_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'user_id' is not null or undefined
      if (user_id === null || user_id === undefined) {
        throw new RequiredError(
          'user_id',
          'Required parameter user_id was null or undefined when calling adminControllerFindOneUser.'
        );
      }
      const localVarPath = `/admin/users/{user_id}`.replace(
        `{${'user_id'}}`,
        encodeURIComponent(String(user_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Genera contraseña temporal para un usuario (solo marsi)
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateTemporaryPasswordByMarsi: async (
      user_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'user_id' is not null or undefined
      if (user_id === null || user_id === undefined) {
        throw new RequiredError(
          'user_id',
          'Required parameter user_id was null or undefined when calling adminControllerGenerateTemporaryPasswordByMarsi.'
        );
      }
      const localVarPath = `/admin/users/{user_id}/password/temporary`.replace(
        `{${'user_id'}}`,
        encodeURIComponent(String(user_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get cache size information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetCacheSize: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/cache/size`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the full organization hierarchy as a tree forest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetOrganizationTree: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/organizations/tree`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Toggles the premium status of an organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerOrganizationTogglePremium: async (
      organization_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'organization_id' is not null or undefined
      if (organization_id === null || organization_id === undefined) {
        throw new RequiredError(
          'organization_id',
          'Required parameter organization_id was null or undefined when calling adminControllerOrganizationTogglePremium.'
        );
      }
      const localVarPath =
        `/admin/organization/{organization_id}/toggle-premium`.replace(
          `{${'organization_id'}}`,
          encodeURIComponent(String(organization_id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Refreshes the access token using the provided refresh token
     * @param {RefreshTokenDto} body Refresh token data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRefreshToken: async (
      body: RefreshTokenDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerRefreshToken.'
        );
      }
      const localVarPath = `/admin/refresh-token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Removes admin role from a user
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRemoveAdminRole: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling adminControllerRemoveAdminRole.'
        );
      }
      const localVarPath = `/admin/admin/{id}/remove`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Solicita email de reseteo de contraseña para un usuario (solo marsi)
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRequestUserPasswordResetByMarsi: async (
      user_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'user_id' is not null or undefined
      if (user_id === null || user_id === undefined) {
        throw new RequiredError(
          'user_id',
          'Required parameter user_id was null or undefined when calling adminControllerRequestUserPasswordResetByMarsi.'
        );
      }
      const localVarPath =
        `/admin/users/{user_id}/password/reset-request`.replace(
          `{${'user_id'}}`,
          encodeURIComponent(String(user_id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unlocks a specific user
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerUnlockUser: async (
      user_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'user_id' is not null or undefined
      if (user_id === null || user_id === undefined) {
        throw new RequiredError(
          'user_id',
          'Required parameter user_id was null or undefined when calling adminControllerUnlockUser.'
        );
      }
      const localVarPath = `/admin/users/{user_id}/unlock`.replace(
        `{${'user_id'}}`,
        encodeURIComponent(String(user_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an organization
     * @param {UpdateOrganizationDto} body New organization data
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerUpdateOrganization: async (
      body: UpdateOrganizationDto,
      organization_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerUpdateOrganization.'
        );
      }
      // verify required parameter 'organization_id' is not null or undefined
      if (organization_id === null || organization_id === undefined) {
        throw new RequiredError(
          'organization_id',
          'Required parameter organization_id was null or undefined when calling adminControllerUpdateOrganization.'
        );
      }
      const localVarPath = `/admin/organization/{organization_id}`.replace(
        `{${'organization_id'}}`,
        encodeURIComponent(String(organization_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates the creator of an organization
     * @param {OrganizationIdCreatorBody} body
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerUpdateOrganizationCreator: async (
      body: OrganizationIdCreatorBody,
      organization_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerUpdateOrganizationCreator.'
        );
      }
      // verify required parameter 'organization_id' is not null or undefined
      if (organization_id === null || organization_id === undefined) {
        throw new RequiredError(
          'organization_id',
          'Required parameter organization_id was null or undefined when calling adminControllerUpdateOrganizationCreator.'
        );
      }
      const localVarPath =
        `/admin/organization/{organization_id}/creator`.replace(
          `{${'organization_id'}}`,
          encodeURIComponent(String(organization_id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates a user
     * @param {UpdateUser} body User data
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerUpdateUserData: async (
      body: UpdateUser,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerUpdateUserData.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling adminControllerUpdateUserData.'
        );
      }
      const localVarPath = `/admin/users/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update firebase token
     * @param {UpdateFirebaseTokenDto} body Firebase token
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerUpdateUserFirebaseToken: async (
      body: UpdateFirebaseTokenDto,
      user_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerUpdateUserFirebaseToken.'
        );
      }
      // verify required parameter 'user_id' is not null or undefined
      if (user_id === null || user_id === undefined) {
        throw new RequiredError(
          'user_id',
          'Required parameter user_id was null or undefined when calling adminControllerUpdateUserFirebaseToken.'
        );
      }
      const localVarPath = `/admin/users/{user_id}/firebase-token`.replace(
        `{${'user_id'}}`,
        encodeURIComponent(String(user_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Activa un usuario pendiente por email
     * @param {AdminActivatependinguserBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerActivatePendingUser(
      body: AdminActivatependinguserBody,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerActivatePendingUser(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Activa un usuario pendiente manualmente (solo marsi)
     * @param {AdminActivateusermanuallyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerActivateUserManually(
      body: AdminActivateusermanuallyBody,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerActivateUserManually(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Clears all cached data from memory. Use with caution!
     * @summary Clear all cache keys from memory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerClearCache(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<any>>
    > {
      const localVarAxiosArgs =
        await AdminApiAxiosParamCreator(
          configuration
        ).adminControllerClearCache(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Creates a new organization
     * @param {CreateOrganization} body Organization data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerCreateOrganization(
      body: CreateOrganization,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Organization>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerCreateOrganization(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Creates a new user
     * @param {CreateUser} body User data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerCreateUser(
      body: CreateUser,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerCreateUser(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Deletes an organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerDeleteOrganization(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerDeleteOrganization(organization_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Elimina un usuario pendiente (solo marsi)
     * @param {string} pending_user_id Pending user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerDeletePendingUser(
      pending_user_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerDeletePendingUser(pending_user_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Deletes a user
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerDeleteUser(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerDeleteUser(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves a single organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerFindOneOrganization(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Organization>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerFindOneOrganization(organization_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves a single user
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerFindOneUser(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerFindOneUser(user_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Genera contraseña temporal para un usuario (solo marsi)
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerGenerateTemporaryPasswordByMarsi(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<any>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerGenerateTemporaryPasswordByMarsi(user_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get cache size information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerGetCacheSize(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<any>>
    > {
      const localVarAxiosArgs =
        await AdminApiAxiosParamCreator(
          configuration
        ).adminControllerGetCacheSize(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the full organization hierarchy as a tree forest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerGetOrganizationTree(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<OrgTreeDto>>>
    > {
      const localVarAxiosArgs =
        await AdminApiAxiosParamCreator(
          configuration
        ).adminControllerGetOrganizationTree(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Toggles the premium status of an organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerOrganizationTogglePremium(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Organization>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerOrganizationTogglePremium(organization_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Refreshes the access token using the provided refresh token
     * @param {RefreshTokenDto} body Refresh token data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerRefreshToken(
      body: RefreshTokenDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<any>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerRefreshToken(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Removes admin role from a user
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerRemoveAdminRole(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerRemoveAdminRole(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Solicita email de reseteo de contraseña para un usuario (solo marsi)
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerRequestUserPasswordResetByMarsi(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<any>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerRequestUserPasswordResetByMarsi(user_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Unlocks a specific user
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUnlockUser(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerUnlockUser(user_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update an organization
     * @param {UpdateOrganizationDto} body New organization data
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateOrganization(
      body: UpdateOrganizationDto,
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Organization>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerUpdateOrganization(body, organization_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Updates the creator of an organization
     * @param {OrganizationIdCreatorBody} body
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateOrganizationCreator(
      body: OrganizationIdCreatorBody,
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Organization>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerUpdateOrganizationCreator(
        body,
        organization_id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Updates a user
     * @param {UpdateUser} body User data
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateUserData(
      body: UpdateUser,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<UserTable>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerUpdateUserData(body, id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update firebase token
     * @param {UpdateFirebaseTokenDto} body Firebase token
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateUserFirebaseToken(
      body: UpdateFirebaseTokenDto,
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await AdminApiAxiosParamCreator(
        configuration
      ).adminControllerUpdateUserFirebaseToken(body, user_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Activa un usuario pendiente por email
     * @param {AdminActivatependinguserBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerActivatePendingUser(
      body: AdminActivatependinguserBody,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerActivatePendingUser(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Activa un usuario pendiente manualmente (solo marsi)
     * @param {AdminActivateusermanuallyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerActivateUserManually(
      body: AdminActivateusermanuallyBody,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerActivateUserManually(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Clears all cached data from memory. Use with caution!
     * @summary Clear all cache keys from memory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerClearCache(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<any>> {
      return AdminApiFp(configuration)
        .adminControllerClearCache(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Creates a new organization
     * @param {CreateOrganization} body Organization data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerCreateOrganization(
      body: CreateOrganization,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Organization>> {
      return AdminApiFp(configuration)
        .adminControllerCreateOrganization(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Creates a new user
     * @param {CreateUser} body User data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerCreateUser(
      body: CreateUser,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerCreateUser(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Deletes an organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerDeleteOrganization(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerDeleteOrganization(organization_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Elimina un usuario pendiente (solo marsi)
     * @param {string} pending_user_id Pending user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerDeletePendingUser(
      pending_user_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerDeletePendingUser(pending_user_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Deletes a user
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerDeleteUser(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerDeleteUser(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves a single organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerFindOneOrganization(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Organization>> {
      return AdminApiFp(configuration)
        .adminControllerFindOneOrganization(organization_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves a single user
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerFindOneUser(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return AdminApiFp(configuration)
        .adminControllerFindOneUser(user_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Genera contraseña temporal para un usuario (solo marsi)
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerGenerateTemporaryPasswordByMarsi(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<any>> {
      return AdminApiFp(configuration)
        .adminControllerGenerateTemporaryPasswordByMarsi(user_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get cache size information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerGetCacheSize(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<any>> {
      return AdminApiFp(configuration)
        .adminControllerGetCacheSize(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the full organization hierarchy as a tree forest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerGetOrganizationTree(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<OrgTreeDto>>> {
      return AdminApiFp(configuration)
        .adminControllerGetOrganizationTree(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Toggles the premium status of an organization
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerOrganizationTogglePremium(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Organization>> {
      return AdminApiFp(configuration)
        .adminControllerOrganizationTogglePremium(organization_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Refreshes the access token using the provided refresh token
     * @param {RefreshTokenDto} body Refresh token data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerRefreshToken(
      body: RefreshTokenDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<any>> {
      return AdminApiFp(configuration)
        .adminControllerRefreshToken(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Removes admin role from a user
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerRemoveAdminRole(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerRemoveAdminRole(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Solicita email de reseteo de contraseña para un usuario (solo marsi)
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerRequestUserPasswordResetByMarsi(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<any>> {
      return AdminApiFp(configuration)
        .adminControllerRequestUserPasswordResetByMarsi(user_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Unlocks a specific user
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUnlockUser(
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerUnlockUser(user_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update an organization
     * @param {UpdateOrganizationDto} body New organization data
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateOrganization(
      body: UpdateOrganizationDto,
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Organization>> {
      return AdminApiFp(configuration)
        .adminControllerUpdateOrganization(body, organization_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Updates the creator of an organization
     * @param {OrganizationIdCreatorBody} body
     * @param {string} organization_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateOrganizationCreator(
      body: OrganizationIdCreatorBody,
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Organization>> {
      return AdminApiFp(configuration)
        .adminControllerUpdateOrganizationCreator(
          body,
          organization_id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Updates a user
     * @param {UpdateUser} body User data
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateUserData(
      body: UpdateUser,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<UserTable>> {
      return AdminApiFp(configuration)
        .adminControllerUpdateUserData(body, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update firebase token
     * @param {UpdateFirebaseTokenDto} body Firebase token
     * @param {string} user_id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerUpdateUserFirebaseToken(
      body: UpdateFirebaseTokenDto,
      user_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return AdminApiFp(configuration)
        .adminControllerUpdateUserFirebaseToken(body, user_id, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
  /**
   *
   * @summary Activa un usuario pendiente por email
   * @param {AdminActivatependinguserBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerActivatePendingUser(
    body: AdminActivatependinguserBody,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerActivatePendingUser(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Activa un usuario pendiente manualmente (solo marsi)
   * @param {AdminActivateusermanuallyBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerActivateUserManually(
    body: AdminActivateusermanuallyBody,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerActivateUserManually(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Clears all cached data from memory. Use with caution!
   * @summary Clear all cache keys from memory
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerClearCache(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return AdminApiFp(this.configuration)
      .adminControllerClearCache(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Creates a new organization
   * @param {CreateOrganization} body Organization data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerCreateOrganization(
    body: CreateOrganization,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Organization>> {
    return AdminApiFp(this.configuration)
      .adminControllerCreateOrganization(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Creates a new user
   * @param {CreateUser} body User data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerCreateUser(
    body: CreateUser,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerCreateUser(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Deletes an organization
   * @param {string} organization_id Organization ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerDeleteOrganization(
    organization_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerDeleteOrganization(organization_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Elimina un usuario pendiente (solo marsi)
   * @param {string} pending_user_id Pending user ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerDeletePendingUser(
    pending_user_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerDeletePendingUser(pending_user_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Deletes a user
   * @param {string} id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerDeleteUser(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerDeleteUser(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves a single organization
   * @param {string} organization_id Organization ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerFindOneOrganization(
    organization_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Organization>> {
    return AdminApiFp(this.configuration)
      .adminControllerFindOneOrganization(organization_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves a single user
   * @param {string} user_id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerFindOneUser(
    user_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return AdminApiFp(this.configuration)
      .adminControllerFindOneUser(user_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Genera contraseña temporal para un usuario (solo marsi)
   * @param {string} user_id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerGenerateTemporaryPasswordByMarsi(
    user_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return AdminApiFp(this.configuration)
      .adminControllerGenerateTemporaryPasswordByMarsi(user_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get cache size information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerGetCacheSize(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return AdminApiFp(this.configuration)
      .adminControllerGetCacheSize(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the full organization hierarchy as a tree forest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerGetOrganizationTree(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<OrgTreeDto>>> {
    return AdminApiFp(this.configuration)
      .adminControllerGetOrganizationTree(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Toggles the premium status of an organization
   * @param {string} organization_id Organization ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerOrganizationTogglePremium(
    organization_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Organization>> {
    return AdminApiFp(this.configuration)
      .adminControllerOrganizationTogglePremium(organization_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Refreshes the access token using the provided refresh token
   * @param {RefreshTokenDto} body Refresh token data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerRefreshToken(
    body: RefreshTokenDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return AdminApiFp(this.configuration)
      .adminControllerRefreshToken(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Removes admin role from a user
   * @param {string} id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerRemoveAdminRole(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerRemoveAdminRole(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Solicita email de reseteo de contraseña para un usuario (solo marsi)
   * @param {string} user_id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerRequestUserPasswordResetByMarsi(
    user_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return AdminApiFp(this.configuration)
      .adminControllerRequestUserPasswordResetByMarsi(user_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Unlocks a specific user
   * @param {string} user_id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerUnlockUser(
    user_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerUnlockUser(user_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update an organization
   * @param {UpdateOrganizationDto} body New organization data
   * @param {string} organization_id Organization ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerUpdateOrganization(
    body: UpdateOrganizationDto,
    organization_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Organization>> {
    return AdminApiFp(this.configuration)
      .adminControllerUpdateOrganization(body, organization_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Updates the creator of an organization
   * @param {OrganizationIdCreatorBody} body
   * @param {string} organization_id Organization ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerUpdateOrganizationCreator(
    body: OrganizationIdCreatorBody,
    organization_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Organization>> {
    return AdminApiFp(this.configuration)
      .adminControllerUpdateOrganizationCreator(body, organization_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Updates a user
   * @param {UpdateUser} body User data
   * @param {string} id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerUpdateUserData(
    body: UpdateUser,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<UserTable>> {
    return AdminApiFp(this.configuration)
      .adminControllerUpdateUserData(body, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update firebase token
   * @param {UpdateFirebaseTokenDto} body Firebase token
   * @param {string} user_id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public async adminControllerUpdateUserFirebaseToken(
    body: UpdateFirebaseTokenDto,
    user_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return AdminApiFp(this.configuration)
      .adminControllerUpdateUserFirebaseToken(body, user_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
